var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useDispatch } from "react-redux";
import { paymentModeAction } from "../../../store/paymentModes/action";
import { plans, plansClearData } from "../../../store/plans/actions";
import { getPlans } from "../../../resources/helper/plans";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { updateNextStepInformation, updateStepByPath, useGetInformationSteps, } from "ah_utility/workflow";
import { useLocation } from "react-router-dom";
import { useStepNavigation } from "ah_utility/NavigationEngine";
import { addToSummary } from "ah_utility/fnxUtils";
var usePlan = function (setRowsQuotes, planSelectedNextStep, setShowModalQuotes, navigate, projectId, enable, page, limit, planPage, planLimit, namePlan, paymentModelSelected, coverTypeSelected, clientId, plan, setPlan, setUpdating, changedPlanId, setPaymentModeData, paymentMode, setPaymentMode, campaignInfo, setCampaignData, setPaymentModelSelected, setChangedPlanId, setSelectedPlanId, setCoverTypeSelected, selectedPlanId, setShowDetails, setShowDetail, setShowCompareDetail, setPlanSelected, setPlanSelectedNextStep, setFiltersQuotes, insuranceType, insurance, runComplete, setSeeToastAlertNext, setNamePlan, dropDown0Options, setSelectedDropDown0, showTablePrimes) {
    var dispatch = useDispatch();
    var pathname = useLocation().pathname;
    var dataNavigation = useStepNavigation({ currentStepId: pathname }).navigation;
    var _a = useGetInformationSteps(pathname), instanceId = _a.instanceId, workFlowId = _a.workFlowId, currentStep = _a.currentStep, nextStep = _a.nextStep;
    var buildDataRowsQuotes = function (responseAllQuote) {
        var dataR = responseAllQuote === null || responseAllQuote === void 0 ? void 0 : responseAllQuote.map(function (item) {
            var _a, _b, _c, _d;
            return ({
                id: item.id,
                storeChannel: "Sucursal 1",
                quote: item.policyId ? (_a = item.policyId) === null || _a === void 0 ? void 0 : _a.code : item.code,
                policyId: (_b = item.policyId) === null || _b === void 0 ? void 0 : _b.id,
                product: (_c = item.productId) === null || _c === void 0 ? void 0 : _c.description,
                status: (_d = item.catalogStatusQuote) === null || _d === void 0 ? void 0 : _d.description,
                name: "".concat(item.firstNameA, " ").concat(item.firstNameB, " ").concat(item.lastNameA, " ").concat(item.lastNameB),
            });
        });
        setRowsQuotes(dataR);
        if (planSelectedNextStep.id) {
            if ((dataR === null || dataR === void 0 ? void 0 : dataR.length) > 0) {
                setShowModalQuotes(true);
            }
            else {
                navigate("/customerForm");
            }
        }
    };
    var setCoverTypeStorybook = function (ct) {
        var optionConverType = [];
        ct.map(function (item) {
            optionConverType.push({
                name: item.description ? item.description : "",
                value: item.id,
                id: item.id,
            });
        });
        return optionConverType;
    };
    var callDispatchPaymentMode = function () {
        if (projectId)
            dispatch(paymentModeAction({ enable: enable, page: page, limit: limit, projectId: projectId }));
    };
    var callDispatchPlan = function () {
        if (!projectId) {
            console.warn("callDispatchPlan: projectId is not defined");
            return;
        }
        // if (paymentMode[0].id !== "-1") {
        dispatch(plans({
            enable: enable,
            page: planPage,
            limit: planLimit,
            projectId: projectId,
            name: namePlan,
            paymentModeId: paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id,
            coverTypeId: coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id,
            clientId: clientId,
            sortBy: "price",
            sortDir: "asc",
        }));
        //}
    };
    var updateCoverPrice = function (item, event) {
        var _a, _b;
        //vamos
        setUpdating(true);
        getPlans(enable, page, limit, projectId, namePlan, (_a = paymentModelSelected.id) !== null && _a !== void 0 ? _a : "", (_b = event.id) !== null && _b !== void 0 ? _b : "", clientId)
            .then(function (response) {
            var _a;
            setUpdating(false);
            var result = response.data.find(function (plan) { return plan.id === changedPlanId; });
            if (result) {
                var newPlan = plan;
                (_a = newPlan.data) === null || _a === void 0 ? void 0 : _a.forEach(function (plan) {
                    var _a;
                    if (plan.id === result.id) {
                        plan.price = (_a = result.price) === null || _a === void 0 ? void 0 : _a.amount;
                    }
                });
                setPlan(__assign({}, newPlan));
            }
        })
            .catch(function (error) {
            setUpdating(false);
        });
    };
    var clickChangePaymentMode = function (event, item, row) {
        if (item === null || item === void 0 ? void 0 : item.id) {
            setChangedPlanId(item.id);
            setCoverTypeSelected(event);
            savePlan(null, event, item.id);
        }
        else {
            if (row) {
            }
            else {
                var t = paymentMode.find(function (p) { return p.id === event; });
                if (t) {
                    setPaymentModelSelected(t);
                    var ms = setPaymentModeData(event, paymentMode);
                    setPaymentMode(ms);
                    if (coverTypeSelected && coverTypeSelected.id) {
                        savePlan(null, coverTypeSelected, selectedPlanId);
                    }
                }
                else {
                    // Check if event is a dropDown0 selection
                    var pt = dropDown0Options === null || dropDown0Options === void 0 ? void 0 : dropDown0Options.find(function (p) { return p.id === event; });
                    if (pt) {
                        setSelectedDropDown0(pt.id);
                    }
                    else {
                        setCampaignData(event);
                    }
                }
                dispatch(plansClearData());
            }
        }
    };
    var clickDetails = function (item) {
        /*Valida si el plan a mostrar el detalle
         * ya tiene la respuesta del api solo muestra
         * el modal  si no la tiene llama al api para
         * recuperar los detalles */
        setShowDetails(true);
        /* if (planSelected.id === item.id) {
                   console.log("--->",planSelected)
                   setPlanSelected(planSelected);
                   setShowDetail(true);
                 }
             */
        // setIsDetailClick(true);
        setPlanSelected(item);
        setShowDetail(true);
    };
    var clickCompareDetails = function (items) {
        // setIsDetailClick(false);
        setShowCompareDetail(true);
    };
    var savePlan = function (item, cv, cp) { return __awaiter(void 0, void 0, void 0, function () {
        var res, coverTypes, rest, Plan, prevStep, currentStep_1, nextStep_1, summaryData, err_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!item) return [3 /*break*/, 5];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep,
                            nextStep: nextStep,
                        })];
                case 2:
                    res = _e.sent();
                    if (res) {
                        coverTypes = item.option, rest = __rest(item, ["option"]);
                        Plan = __assign(__assign({}, item), { coverTypes: cv });
                        updateStepByPath(pathname, {
                            Plan: Plan,
                            paymentMode: paymentModelSelected,
                        });
                        prevStep = (_a = res.upcomingFormStep) === null || _a === void 0 ? void 0 : _a.prevSteps[0];
                        currentStep_1 = (_b = res.upcomingFormStep) === null || _b === void 0 ? void 0 : _b.id;
                        nextStep_1 = (_c = res.upcomingFormStep) === null || _c === void 0 ? void 0 : _c.nextSteps[0];
                        summaryData = [
                            {
                                label: "Plan",
                                value: item.name || "",
                            },
                            { label: "Tipo de cobertura", value: (cv === null || cv === void 0 ? void 0 : cv.name) || "" },
                            {
                                label: "Modalidad de pago",
                                value: item.period || "",
                            },
                        ];
                        // Solo agregar Prima si showTablePrimes es false
                        if (!showTablePrimes) {
                            summaryData.push({
                                label: "Prima",
                                value: "".concat(item.currency, " ").concat(item.price) || "",
                            });
                        }
                        // Agregar Campaña
                        summaryData.push({
                            label: "Campaña",
                            value: ((_d = campaignInfo === null || campaignInfo === void 0 ? void 0 : campaignInfo[0]) === null || _d === void 0 ? void 0 : _d.name) || "",
                        });
                        addToSummary(summaryData);
                        updateNextStepInformation({
                            stepKey: pathname,
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.next));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _e.sent();
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    if (cp === selectedPlanId) {
                    }
                    _e.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onClickSelectRowQuote = function (params) {
        if (params.status.toLowerCase() === "cotizada") {
            navigate("/confirmationForm/" + params.id + "/true/true");
        }
        else {
            navigate("/confirmationForm/" + params.id + "/false/true");
        }
    };
    var clickCard = function (card) {
        var _a;
        var coverType = (_a = card.option) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.id === card.selected; });
        setSelectedPlanId(card.id);
        setCoverTypeSelected(coverType);
        setPlanSelectedNextStep(card);
        savePlan(card, coverType, null);
        onClickNext(card);
    };
    var clickAcquire = function (item) {
        var _a;
        var options = [];
        plan &&
            ((_a = plan.data) === null || _a === void 0 ? void 0 : _a.map(function (it) {
                if (it.id === item.id) {
                    options.push(it);
                }
            }));
        item.option = options;
        savePlan(item, coverTypeSelected, null);
    };
    var onClickNext = function (card) {
        if (card.id.length > 0) {
            setFiltersQuotes([
                {
                    label: insuranceType,
                    name: "Tipo de Seguro",
                    type: "label",
                },
                {
                    label: insurance,
                    name: "Seguro",
                    type: "label",
                },
                {
                    label: card.name,
                    name: "Plan",
                    type: "label",
                },
                {
                    label: campaignInfo ? campaignInfo[0].name : "",
                    name: "Campaña",
                    type: "label",
                },
            ]);
        }
        else {
            /*Cuando no se tiene ningun plan selecionado */
            setSeeToastAlertNext({
                show: true,
                message: "¡Se debe de seleccionar un plan!",
                type: typeAlert.info,
            });
        }
    };
    var handleCancelSearch = function () {
        setNamePlan("");
        dispatch(plans({
            enable: enable,
            page: page,
            limit: limit,
            projectId: projectId,
            name: "",
            paymentModeId: paymentModelSelected.id,
            coverTypeId: coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id,
            clientId: clientId,
        }));
    };
    return {
        buildDataRowsQuotes: buildDataRowsQuotes,
        setCoverTypeStorybook: setCoverTypeStorybook,
        callDispatchPaymentMode: callDispatchPaymentMode,
        callDispatchPlan: callDispatchPlan,
        updateCoverPrice: updateCoverPrice,
        clickChangePaymentMode: clickChangePaymentMode,
        clickDetails: clickDetails,
        clickCompareDetails: clickCompareDetails,
        savePlan: savePlan,
        onClickSelectRowQuote: onClickSelectRowQuote,
        clickCard: clickCard,
        clickAcquire: clickAcquire,
        onClickNext: onClickNext,
        handleCancelSearch: handleCancelSearch,
    };
};
export default usePlan;
